export const maxAge = 365 * 24 * 60 * 60;
export const domain = process.env.REACT_APP_COOKIE_DOMAIN;
export const path = '/';

export const cookieOptions = {
  domain,
  maxAge,
  path,
};
